import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountService } from '../services/account.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {

	constructor(private accountService: AccountService, private router: Router) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		let userAuthenticated = this.accountService.isAuthenticated();
		if (!userAuthenticated) {
            if (this.accountService.goHome) {
                this.router.navigate(['/']);
                this.accountService.goHome = false;
            } else {
                this.router.navigate(['/login']);
            }
		}
		return userAuthenticated;
	}

}
